import React from "react"
import { ImportacaoClientesContextProvider } from "./context/ImportacaoClientesContextProvider"
import { ImportacaoClientesFornecedor } from "./ImportacaoClientesFornecedor"

export function Index() {
    return (
        <ImportacaoClientesContextProvider>
            <ImportacaoClientesFornecedor />
        </ImportacaoClientesContextProvider>
    )
}
